import { Button, CircularProgress } from "@mui/material";
import BookOrderDialogShell from "./BookOrderDialogShell";
import styles from "./MultiAccountOrderModal.module.css";

function MultiAccountOrderModal({
  open,
  onClose,
  onConfirm,
  modalMode,
  headerQuantity,
  headerDisclosed,
  headerBidAsk,
  children,
  layoutVariant = "holding",
  paperClassName = "",
  confirmDisabled = false,
  title = "Multi Account Order Entry",
  submitting = false,
}) {
  const confirmLabel = modalMode === "add-more" ? "Add More" : "SQ OFF";
  const loadingLabel = modalMode === "add-more" ? "Adding..." : "Squaring off...";

  const body = (
    <fieldset disabled={submitting} className={styles["modal-order-fieldset"]}>
      {children}
    </fieldset>
  );

  const header = (
    <div className={styles["modal-header-stacked"]}>
      <div className={styles["modal-header"]}>
        <div className={styles["modal-header-cell"]}>
          <span className={styles["modal-header-label"]}>Trading Symbol</span>
        </div>
        <div className={styles["modal-header-cell"]}>
          <span className={styles["modal-header-label"]}>Accounts</span>
        </div>
        <div className={styles["modal-header-cell"]}>
          <span className={`${styles["modal-header-label"]} ${styles["modal-header-label-qty"]}`}>
            Quantity
          </span>
        </div>
        <div className={styles["modal-header-cell"]}>
          <span className={`${styles["modal-header-label"]} ${styles["modal-header-label-qty"]}`}>
            Disclosed Quantity
          </span>
        </div>
        <div className={styles["modal-header-cell"]}>
          <span className={styles["modal-header-label"]}>Bid-Ask</span>
        </div>
      </div>
      <div className={`${styles["modal-header"]} ${styles["modal-header-inputs-row"]}`}>
        <div
          className={`${styles["modal-header-cell"]} ${styles["modal-header-inputs-spacer"]}`}
          aria-hidden={true}
        />
        <div
          className={`${styles["modal-header-cell"]} ${styles["modal-header-inputs-spacer"]}`}
          aria-hidden={true}
        />
        <div className={styles["modal-header-cell"]}>{headerQuantity}</div>
        <div className={styles["modal-header-cell"]}>{headerDisclosed}</div>
        <div className={styles["modal-header-cell"]}>{headerBidAsk}</div>
      </div>
    </div>
  );

  const footer = (
    <>
      <Button
        variant="outlined"
        onClick={onClose}
        disabled={submitting}
        className={styles["modal-cancel-button"]}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={confirmDisabled || submitting}
        className={styles["modal-sqoff-button"]}
        sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
      >
        {submitting ? (
          <>
            <CircularProgress size={18} color="inherit" thickness={5} />
            {loadingLabel}
          </>
        ) : (
          confirmLabel
        )}
      </Button>
    </>
  );

  return (
    <BookOrderDialogShell
      open={open}
      onClose={onClose}
      paperClassName={paperClassName}
      layoutVariant={layoutVariant}
      showTitleBar
      title={title}
      header={header}
      footer={footer}
      orderEntryGrid
      closeDisabled={submitting}
    >
      {body}
    </BookOrderDialogShell>
  );
}

export default MultiAccountOrderModal;
